import BootstrapModal from "bootstrap/js/dist/modal";

import { UnshadowedElement, html } from "../lib/unshadowed.js";

/**
 * Wraps a link so clicking it plays an embedded video in a modal.
 */
export class VideoModal extends UnshadowedElement {
    static elementName() { return "video-modal" }

    static properties = {
        /** Embed URL for the iframe, e.g. https://www.youtube.com/embed/{id}?autoplay=1 */
        src: { type: String },
        /** Accessible name for the modal */
        label: { type: String },

        open: { state: true, type: Boolean },
        shown: { state: true, type: Boolean },
    }

    firstUpdated() {
        // Map the click on the link to opening the modal, and prevent the default navigation
        this.querySelector("a").addEventListener("click", (e) => {
            e.preventDefault();
            this.open = true;
        });
    }

    render() {
        // Only rendered while open, so closing removes the iframe and stops playback
        if (!this.open) {
            return null;
        }
        // The iframe waits until the modal is visible: CookieYes sizes its consent
        // placeholder from the blocked iframe, and skips it if the iframe measures 0x0
        return html`
            <div class="modal fade video-modal" tabindex="-1" aria-label=${this.label}>
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        ${this.shown ? html`
                            <iframe src=${this.src} allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>
                        ` : null}
                    </div>
                </div>
            </div>
        `;
    }

    updated(changed) {
        if (changed.has("open") && this.open) {
            const modalElement = this.querySelector(".modal");
            modalElement.addEventListener("shown.bs.modal", () => { this.shown = true; });
            modalElement.addEventListener("hidden.bs.modal", () => {
                BootstrapModal.getInstance(modalElement).dispose();
                this.open = false;
                this.shown = false;
            });
            BootstrapModal.getOrCreateInstance(modalElement).show();
        }
    }
}
